import { type BuildQuizListItem } from '@/views/build/form/schema/BuildQuizListSchema';

/**
 * 빌드 폼에 이미 담긴 문제 은행 문항 id. 은행에서 담아온 문항만 `bankItemId` 를 갖고,
 * 담은 뒤 문항을 고쳐도 출처는 남는다.
 */
export const getAddedQuizBankItemIds = (quizList: BuildQuizListItem[]) =>
  quizList
    .map(quiz => quiz.bankItemId)
    .filter((id): id is string => Boolean(id));
